import React, { useState, useEffect } from 'react';

// Amplify
import { graphqlOperation } from 'aws-amplify';

// Components
import { Table } from 'antd';

// Mock
// import AddItem from './AddItem';
// import EditItem from './EditItem';
import { timesheetsByCustomer } from '../../graphql/queries';
import { Link } from 'react-router-dom';
import { Timesheet, IConnectListQuery } from '../../types';
import { TimesheetStatus } from '../../API';
import { History } from 'history';
import withAppState, { IAppStateComponentProps } from '../../state/withAppState';
import { ConnectedInfiniteTable } from 'basealpha-ui';

class TimesheetTable extends ConnectedInfiniteTable<Timesheet, 'timesheetsByCustomer'> {}

type Props = IAppStateComponentProps & { status?: TimesheetStatus; history: History; employeeId?: number };
const List = (props: Props): React.ReactElement => {
  let fltr: any;
  if (props.appState.user.accessToFullData) {
    fltr = null;
  } else {
    fltr = {
      or: [
        { approver1: { eq: props.appState.user.id } },
        { approver2: { eq: props.appState.user.id } },
      ],
    };
  }
  const queryGenerator = (nextToken: string | null): { query: any; variables: {} } => {
    if (fltr) {
      return graphqlOperation(timesheetsByCustomer, {
        customerId: `${props.appState.user.customerId}`,
        statusFromDate: { beginsWith: { status: props.status, fromDate: null } },
        filter: fltr,
        sortDirection: 'DESC',
        nextToken,
        limit: 20,
      });
    } else {
      return graphqlOperation(timesheetsByCustomer, {
        customerId: `${props.appState.user.customerId}`,
        statusFromDate: { beginsWith: { status: props.status, fromDate: null } },
        sortDirection: 'DESC',
        nextToken,
        limit: 20,
      });
    }
  };

  const columns = [
    {
      title: 'Contractor',
      dataIndex: 'employeeName',
      key: 'employeeName',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'From Date',
      dataIndex: 'fromDate',
      key: 'fromDate',
    },
    {
      title: 'To Date',
      dataIndex: 'toDate',
      key: 'toDate',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (text: string, record: Timesheet): string => {
        return record.status || 'PENDING';
      },
    },
  ];
  return (
    <React.Fragment>
      <br />
      <TimesheetTable
        tableId="timesheet-table"
        onRowClick={(record: Timesheet, rowIndex: number): void => {
          props.history.push(`/timesheets/${record.id}`, { record });
        }}
        columns={columns}
        queryGenerator={queryGenerator}
        opName="timesheetsByCustomer"
        autoLoadEnabled={true}
      />
    </React.Fragment>
  );
};

export default withAppState(List);
